var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var LoginController = /** @class */ (function () {
    function LoginController() {
    }
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/register/{encodedString}" and http method "GET" to call the back-end.
    
        * @param {string} encodedString
        * @returns {string}
    ******************************************************************************************************/
    LoginController.Register = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/register/{encodedString}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/register" and http method "POST" to call the back-end.
    
        * @param {RegistrationCode} code
        * @returns {string}
    ******************************************************************************************************/
    LoginController.RegisterPost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/register", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.code
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/register/welcome" and http method "POST" to call the back-end.
    
        * @param {RegistrationCode} code
        * @returns {RegisterResponse}
    ******************************************************************************************************/
    LoginController.RegisterWelcomePost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/register/welcome", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.code
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/reset/{encodedString}" and http method "GET" to call the back-end.
    
        * @param {string} encodedString
        * @returns {string}
    ******************************************************************************************************/
    LoginController.Reset = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/reset/{encodedString}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/login/token/renew" and http method "POST" to call the back-end.
    
        * @param {string} token
        * @returns {string}
    ******************************************************************************************************/
    LoginController.RenewCookie = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/token/renew", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/login/token/renew/full" and http method "POST" to call the back-end.
    
        * @returns {string}
    ******************************************************************************************************/
    LoginController.RenewToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/token/renew/full", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/login/password" and http method "POST" to call the back-end.
    
        * @param {LoginDto} login
        * @returns {string}
    ******************************************************************************************************/
    LoginController.ChangePassword = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/password", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.login
        });
    };
    /*****************************************************************************************************
        * Is using route "api/login/disableShowGroupWelcome" and http method "POST" to call the back-end.
    
        * @returns {string}
    ******************************************************************************************************/
    LoginController.DisableShowGroupWelcome = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/disableShowGroupWelcome", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/login/password/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {LoginDto} login
        * @returns {void}
    ******************************************************************************************************/
    LoginController.ChangePasswordForId = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/password/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.login
        });
    };
    /*****************************************************************************************************
        * Is using route "api/login/tries/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    LoginController.ResetLoginTries = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/tries/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/login/check" and http method "POST" to call the back-end.
    
        * @param {LoginDto} login
        * @returns {void}
    ******************************************************************************************************/
    LoginController.LoginCheck = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/check", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.login
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/platform" and http method "POST" to call the back-end.
    
        * @param {LoginDto} login
        * @param {BrowserInfo} browserInfo
        * @returns {string}
    ******************************************************************************************************/
    LoginController.LoginWithBrowserInfo = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("login", JSON.stringify(data.login));
        fd.append("browserInfo", JSON.stringify(data.browserInfo));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/platform", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login" and http method "POST" to call the back-end.
    
        * @param {LoginDto} login
        * @returns {string}
    ******************************************************************************************************/
    LoginController.Login = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.login
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/token" and http method "GET" to call the back-end.
    
        * @returns {string}
    ******************************************************************************************************/
    LoginController.LoginGetToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/token", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/token" and http method "POST" to call the back-end.
    
        * @param {string} token
        * @returns {string}
    ******************************************************************************************************/
    LoginController.LoginToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/token", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/become/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {string}
    ******************************************************************************************************/
    LoginController.BecomeUser = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/become/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/login/reset" and http method "POST" to call the back-end.
    
        * @param {LoginDto} login
        * @returns {void}
    ******************************************************************************************************/
    LoginController.LoginReset = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/login/reset", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.login
        });
    };
    /*****************************************************************************************************
        * Is using route "api/logout" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    LoginController.Logout = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/logout", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/loginSaml" and http method "POST" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    LoginController.LoginSamlToken = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/loginSaml", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return LoginController;
}());
export { LoginController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=LoginController.js.map